<template>
    <div class="animated fadeIn">
        <b-row>
          <b-col sm="12">
              <b-card>
                <div slot="header">
                    <b-row>
                        <b-col sm="3">
                            <strong>Audit Status Dashboard</strong>
                        </b-col>
                        <div id="listloader" v-if="loader">
                          <div class="listloader"></div>
                        </div>
                            <b-col sm="4">
                              <b-form-group label="Hub Name :" :label-cols="3" >
                                <!-- <b-form-select v-model="selectHub" :disabled="isSuperAdmin=='2'">
                                    <option :value="null">ALL</option>
                                    <option v-for="hub in optionsHub" v-bind:value="hub.hubid"
                                        v-if="hub.hubid && hub.hubname">
                                        {{hub.hubname}}</option>
                                </b-form-select> -->
                                <ejs-multiselect  id='multi_select2'  placeholder="Select Hub Name" v-model="selectHub" :dataSource='optionsHub' :showSelectAll='showSelectAll' selectAllText="Select All" unSelectAllText="unSelect All" :disabled="isSuperAdmin=='2' || isSuperAdmin=='3'" :fields='fieldWH' :allowCustomValue='allowCustomValue'  enableGroupCheckBox="true" mode="CheckBox"
                                ></ejs-multiselect>

                                <!-- <v-select v-model="selectHub" :options="optionsHub" multiple placeholder="Select Hub Name" @input="handleSelection"  class="custom-v-select"></v-select> -->
                            </b-form-group>
                            </b-col>
                            <b-col sm="3">
                                <b-form-group label="Date :"  :label-cols="4" >
                                  <b-form-select v-model="selectDate" :options = dateOptions @change="displayDashboardData" :disabled="selectHub.length == 0" >
                                      <template #first>
                                        <option disabled value="null">-- Select Date --</option>
                                      </template>
                                  </b-form-select>
                                </b-form-group>
                            </b-col>
                            <b-col sm="2">
                                <a :href="loadurl" target="_blank" rel="noopener noreferrer">
                                <b-button variant="primary" @click="downloadFile">Download  &nbsp;<i class="fa fa-download" aria-hidden="true"></i></b-button>
                            </a>
                            </b-col>
                    </b-row>
                </div>
                <b-col cols="12">
              <b-card header-tag="header" footer-tag="footer" style="height: max-content;">
                
                <b-row>
                <b-col cols="7">
                <h4><label class="text-center" style="color: grey;">Audit Status</label></h4> 
                <div v-if="isBarDataEmpty" style="color: gray; text-align: center; font-size: 20px; font-weight: bold; margin-top: 20%;">No data available for charts.</div>
                <div v-else style="width: 100%; height: 500px;"><canvas id="statusBarChart"></canvas></div>
                </b-col>
                <b-col cols="1" class="d-flex align-items-center justify-content-center">
                    <div class="vertical-line"></div>
                </b-col>
                <b-col cols="4">
                  <div v-if="isPieDataEmpty" style="color: gray; text-align: center; font-size: 20px; font-weight: bold; margin-top: 40%;">No data available for charts.</div>
                 <div v-else style="width: 100%; height: 500px;"><canvas id="statusPieChart"></canvas></div> 
                </b-col>
                </b-row>
              </b-card>
            </b-col>

              </b-card>
            </b-col>
        </b-row>
    </div>
</template>
<script>
import CONSTANTS from "@/utils/constants";
// import Chart from 'chart.js';
import Chart from 'chart.js/auto';

export default {
    data() {
        return{
            selectDate: null,
            loader: false,
            selectHub : [],
            showSelectAll : true,
            optionsHub : [],
            isSuperAdmin : '',
            dateOptions: [],
            fieldWH:{ text: 'name', value: 'id' },
            chartData: [
                { status: 'Booking Pending', count: 0, bgcolor: '#6699ff' },
                { status: 'Booking Done', count: 0, bgcolor:'#6699ff' },
                { status: 'Hub In Scan Pending', count: 0, bgcolor: '#6699ff' },
                { status: 'Hub In Scan', count: 0, bgcolor:'#6699ff' },
                { status: 'Zone In', count: 0, bgcolor: '#6699ff' },
                { status: 'Zone Out', count: 0, bgcolor:'#6699ff' },
                { status: 'Dispatch Out Scan',count: 0, bgcolor:'#6699ff' },
                { status: 'Pick Done', count: 0, bgcolor:'#6699ff' },
                { status: 'Intransit', count: 0, bgcolor:'#6699ff' },
                { status: 'OFD', count: 0, bgcolor:'#6699ff' },
            ],
            pieData: [
                { status: 'Not Inwarded', count: 0, bgcolor:'#6699ff' },
                { status: 'Not Dispatched', count: 0, bgcolor:'#e65c00' },
                { status: 'Zone Mismatch', count: 0, bgcolor:'#808080' },
            ],
            barChartInstance: null,
            pieChartInstance: null,
            isBarDataEmpty: '',
            isPieDataEmpty: '',
            loadurl: ''

        }
    },
    created: function() {
      var userdata = localStorage.getItem("userData");
      var userInfo = JSON.parse(userdata);
      this.isSuperAdmin = userInfo.user_type;
      this.allHubList();
      if(this.isSuperAdmin == '2' || this.isSuperAdmin == '3'){
        this.selectHub = [userInfo.hub_id];
      }
      this.displayDashboardData();
    },
    watch: {
    selectHub(newValue) {
     if(this.selectHub.length == 0){
        this.selectDate = null;
        this.displayDashboardData();
     }
    this.allDateListing(newValue);
    },
    
},
    methods: {

        allHubList:function(){
          this.loader = true;
          var userdata = localStorage.getItem('userData')
          var userInfo = JSON.parse(userdata)
          
          const Obj = {
          };
          this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/getAllHubsForDropDown`, Obj)
                .then(result => {
                  this.loader = false;
                    if (result.body.returnmsg == 'Successful') {
                        this.optionsHub = result.body.returnvalue.map(hub => ({
                            name: hub.hub_title,
                            id: hub.hub_id
                        }));

                        if (this.isSuperAdmin == '2' && userInfo.hub_id) {
                            let selectedHubs = this.optionsHub.filter(hub => hub.id == userInfo.hub_id);
                            if (selectedHubs.length > 0) {
                                this.selectHub = [selectedHubs[0].id]; 
                            }
                        }
                    }
                })
          .catch(ex => {
              console.log("error-----", ex);
          });
      },

      allDateListing(value){
          this.loader = true;
          const Obj = {
            hubid: value
          };
          this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/getAllDatesForDropDown`, Obj)
                .then(result => {
                  this.loader = false;
                  if (result.body.returnmsg == 'Successful') {
                        this.dateOptions = result.body.returnvalue.map(date => ({
                            text: date.dates,
                            value: date.dates
                        }));
                      }
                })
              .catch(ex => {
              console.log("error-----", ex);
          });
      },

        displayDashboardData: function() {
        this.loader = true;
        var userdata = localStorage.getItem("userData");
        var userInfo = JSON.parse(userdata);
        this.isBarDataEmpty = '',
        this.isPieDataEmpty = ''
        const obj = {
              hub_ids: this.selectHub,
              date: this.selectDate
        };
      
        this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/auditStatusDashboard`,obj).then((result) => {
          this.loader = false;
          if(result.body.returnmsg=='Successful'){
            const barVal = result.body.barGraphData;
            const pieVal = result.body.pieChartData;
            
            this.chartData = [
                { status: 'Booking Pending', count: barVal[0].BookingPending , bgcolor: '#6699ff' },
                { status: 'Booking Done', count: barVal[0].BookingDone, bgcolor:'#6699ff' },
                { status: 'Hub In Scan Pending', count: barVal[0].HubInScanPending, bgcolor: '#6699ff' },
                { status: 'Hub In Scan', count: barVal[0].HubInScan, bgcolor:'#6699ff' },
                { status: 'Zone In', count: barVal[0].ZoneInScan, bgcolor: '#6699ff' },
                { status: 'Zone Out', count: barVal[0].ZoneOutScan, bgcolor:'#6699ff' },
                { status: 'Dispatch Out Scan',count: barVal[0].DispatchOutScan, bgcolor:'#6699ff' },
                { status: 'Pick Done', count: barVal[0].PickDone, bgcolor:'#6699ff' },
                { status: 'Intransit', count: barVal[0].INTransit, bgcolor:'#6699ff' },
                { status: 'OFD', count: barVal[0].OFD, bgcolor:'#6699ff' },
            ]
            this.pieData = [
                { status: 'Not Inwarded', count: pieVal[0].notInwarded, bgcolor:'#6699ff' },
                { status: 'Not Dispatched', count: pieVal[0].notDispatched, bgcolor:'#e65c00' },
                { status: 'Zone Mismatch', count: pieVal[0].zoneMismatch, bgcolor:'#808080' },
            ]
              this.displayCharts();
          }else if(result.body.returnmsg != 'Unsuccessful'){
              this.$fire({
                text: "There is no audit for this Hub!",
                type: "error",
                timer: 30000
              });     
            }
          else{
            this.$fire({
                text: result.body.returnvalue,
                type: "error",
                timer: 30000
              });
          }
        })
        .catch(error=>{
          this.$fire({
            text: error.message,
            type: "error",
            timer: 30000
          });
        })
      },

      downloadFile() {
    const hubIds = this.selectHub.join(','); 
    const auditDate = this.selectDate;
    this.loadurl = `${CONSTANTS.MISREPORT_API_URL}/auditStatusDashboardDownload?hub_ids=${hubIds}&audit_date=${auditDate}`;
    
    // window.open(downloadUrl, '_blank');
},

    displayCharts: function(){
            const barCanvas = document.getElementById('statusBarChart');
            const pieCanvas = document.getElementById('statusPieChart');

            if (this.barChartInstance) {
                this.barChartInstance.destroy();
            }
            if (this.pieChartInstance) {
                this.pieChartInstance.destroy();
            }

            this.isBarDataEmpty = this.chartData.every(item => item.count === 0);
            this.isPieDataEmpty = this.pieData.every(item => item.count === 0);
            console.log("_____________________________________________BAR_-",this.isBarDataEmpty);
            console.log("_____________________________________________PIE_-",this.isPieDataEmpty);

            this.barChartInstance = new Chart(barCanvas,
          {
            type: 'bar',
            data: {
              labels: this.chartData.map(row => row.status),
              datasets: [
                {
                  label: 'Count',
                  data: this.chartData.map(row => parseInt(row.count)),
                  backgroundColor: this.chartData.map(row => row.bgcolor),
                }
              ],
            },
            options: {
              scales: {
                y: {  
                        beginAtZero: true
                    },
                    x: {
                        ticks: {
                            autoSkip: false
                        }
                    }
              },
            }
          }
        );

        this.pieChartInstance = new Chart(pieCanvas,
          {
            type: 'pie',
            data: {
              labels: this.pieData.map(row => row.status),
              datasets: [
                {
                  label: 'Audit Status Count',
                  data: this.pieData.map(row => row.count),
                  backgroundColor: this.pieData.map(row => row.bgcolor),
                }
              ]
            },
          }
        );

      },

    }
}

</script>
<!-- <style scoped>
  .vertical-line {
    width: 1px; 
    height: 100%; 
    background-color: lightgray;
  }

</style> -->